export default __webpack_public_path__ + "static/media/logo.c976c9d5.png";